export default "/img/SR.73afaee974b83685374ed399881c971b.png";